import { render, staticRenderFns } from "./traffic-note.vue?vue&type=template&id=5f25c3d7&"
import script from "./traffic-note.vue?vue&type=script&lang=js&"
export * from "./traffic-note.vue?vue&type=script&lang=js&"
import style0 from "./traffic-note.vue?vue&type=style&index=0&id=5f25c3d7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports